import React from 'react';
import { ContactCommonPage } from '../../commonPage';
import { Commons } from '../../utilities';

const ContactPage = () => {



    const contactSubmit = (credentials) => {

    }

    return (
        <ContactCommonPage
            userType={Commons.userType.doctor}
            closeNavigate="/doctor"
            contactSubmit={contactSubmit}
        />
    )
}

export default ContactPage;
